export class Point {
  #x: number;
  #y: number;

  get x() {
    return this.#x;
  }

  get y() {
    return this.#y;
  }

  constructor(x: number, y: number) {
    this.#x = x;
    this.#y = y;
  }

  distance(other: Point) {
    return pointDistance(this, other);
  }
}

export interface PointOptions {
  x: number;
  y: number;
}

export function createPoint(options: PointOptions) {
  return new Point(options.x, options.y);
}

export function pointDistance(p1: Point, p2: Point) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;

  const result = Math.sqrt((dx * dx) + (dy * dy));
  return Math.abs(result);
}
